import { type FilterValues } from "components/filters/FilterContext";
import { mapCompanyFilterToInstruction, mapKeywordFilterToInstruction, mapResponseToCompanyFilter, mapResponseToKeywordFilter, mapResponseToVisibilityFilter, mapVisibilityFilterToInstruction } from "components/filters/mappingUtils";

export const getMapFilterValuesToInstructionFn = (clientId: number) => (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedBookkeepingInstruction => {
  return {
    clientId,
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    companyIds: mapCompanyFilterToInstruction(filter.company),
    visible: mapVisibilityFilterToInstruction(filter.visible),

    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListBookkeepingFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  company: mapResponseToCompanyFilter(response.companies),
  visible: mapResponseToVisibilityFilter(response.visible)
});